export default __webpack_public_path__ + "static/media/404.9de8a6e6.svg";